export default "__VITE_ASSET__94cb0288__"